import { numberFormat } from '../helpers';

Vue.filter('trim', value => value.trim());
Vue.filter('round', value => Math.round(value * 100) / 100);
Vue.filter('money', value => numberFormat(value, 2, ',', '.'));
Vue.filter('date', value => moment(value).format('DD.MM.YYYY'));
Vue.filter('date_long', value => moment(value).format('dddd, DD. MMMM YYYY'));
Vue.filter('date_text', value => moment(value).format('DD. MMM'));
